export { default } from "./AppInputLabel";
export type { AppInputLabelProps } from "./AppInputLabel";
